module.exports = __webpack_public_path__ + "img/bj2.3c319082.png";